import currency from 'currency.js';
const czk = value => currency(value, { separator: ' ', decimal: ',', precision: 0, symbol: 'Kč', formatWithSymbol: true, pattern: '# !' });

export { czk };